module.exports = __webpack_public_path__ + "img/fruitsmorceaux.d6b23667.png";